import React from "react";
import HomeContent from "../function-components/HomeContent/HomeContent.jsx";

function Home({ value, setValue, languageValue, setLanguageValue }) {
  return (
    <>
      <HomeContent value={value} setValue={setValue} languageValue={languageValue} setLanguageValue={setLanguageValue}/>
    </>
  );
}

export default Home;
